import { Menu as IconMenu } from '@mui/icons-material'
import { styled } from '@mui/material'
import React from 'react'

import { COLORS, THEME_CONST, Z_INDEX } from '../../../theme'
import { Collapsible } from '../../Collapsible'

const StyledCollapsible = styled(Collapsible)`
  z-index: ${Z_INDEX.sidebar};
  & .MuiDrawer-paper {
    position: absolute;
    padding-top: ${THEME_CONST.navHeight}px;
    z-index: ${Z_INDEX.sidebar};
  }

  svg {
    fill: currentColor;
  }
`

const SideIcon = styled('div')`
  display: flex;
  border-radius: 8px;
  padding: 12px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background-color: transparent;
  height: unset;
  margin: 8px 12px;
  color: ${COLORS.white.main};

  svg {
    fill: ${COLORS.white.main};
  }
`

interface Props {
  children?: React.ReactNode
}

export function ApplicationSidebarWrapper(props: Props) {
  const { children } = props

  return (
    <StyledCollapsible variant="permanent" anchor="left" open={false}>
      <SideIcon>
        <IconMenu />
      </SideIcon>
      {children}
    </StyledCollapsible>
  )
}
